
import Vue from 'vue';
import VSkeletonShimmer from '@/components/skeletonShimmer/VSkeletonShimmer.vue';

Vue.component('VSkeletonShimmer', VSkeletonShimmer);
